import { API, getRequest, patchRequest, postRequest } from '@/api/api';

import type {
  AdminProviderReportsPageDto,
  CreateProviderReportDto,
  ProviderReportFormValues,
  ProviderReportStatus,
  SubmittedProviderReportDto,
  SubmittedProviderReportsPageDto,
  UpdateProviderReportStatusDto,
} from './provider-reports.dto';
import {
  mapAdminProviderReport,
  mapProviderReportToDto,
  mapSubmittedProviderReport,
} from './provider-reports.mappers';

// Both lists are read for one provider at a time, which never comes near a page.
const PER_PROVIDER_PAGE = { limit: 100, page: 1 };

export const getMyProviderReports = async (serviceProviderId: string) => {
  const { data } = await getRequest<SubmittedProviderReportsPageDto>(
    API.SERVICE_PROVIDERS,
    'service-provider/reports',
    false,
    { ...PER_PROVIDER_PAGE, service_provider_id: serviceProviderId },
  );
  return data.items.map(mapSubmittedProviderReport);
};

export const createProviderReport = async (
  serviceProviderId: string,
  values: ProviderReportFormValues,
) => {
  const { data } = await postRequest<SubmittedProviderReportDto, CreateProviderReportDto>(
    API.SERVICE_PROVIDERS,
    `service-provider/${serviceProviderId}/report`,
    mapProviderReportToDto(values),
  );
  return mapSubmittedProviderReport(data);
};

/** Platform Admin only — the service answers 403 to anyone else. */
export const getAdminProviderReports = async (serviceProviderId: string) => {
  const { data } = await getRequest<AdminProviderReportsPageDto>(
    API.SERVICE_PROVIDERS,
    'service-provider/admin/reports',
    false,
    { ...PER_PROVIDER_PAGE, service_provider_id: serviceProviderId },
  );
  return data.items.map(mapAdminProviderReport);
};

/** Platform Admin only. */
export const updateProviderReportStatus = async (
  reportId: string,
  status: ProviderReportStatus,
) => {
  await patchRequest<void, UpdateProviderReportStatusDto>(
    API.SERVICE_PROVIDERS,
    `service-provider/admin/reports/${reportId}/status`,
    { status },
  );
};
